import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

/**
 * Fires a `page_view` analytics event on every route change. Mounted once from
 * App.js inside <BrowserRouter> so it always has access to react-router state.
 * De-dupes back-to-back events for the same path (prevents Strict-Mode doubles).
 */
export default function RouteTracker() {
  const loc = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    const key = loc.pathname + loc.search;
    if (lastPath.current === key) return;
    lastPath.current = key;
    track("page_view", { path: loc.pathname, search: loc.search || undefined });
  }, [loc.pathname, loc.search]);
  return null;
}
